import { environment } from '@environments/environment';

export const GET_FAQS_QUERY = (
  langcode: string,
  opts: {
    excludeFaqWithQuestion?: string;
    includeOnlyFaqWithIds?: string[];
    category?: string;
  }
) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_faq ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          ...(opts.category
            ? [
                {
                  term: {
                    name: opts.category,
                  },
                },
              ]
            : []),
          ...(opts.includeOnlyFaqWithIds
            ? [
                {
                  terms: {
                    search_api_id: opts.includeOnlyFaqWithIds,
                  },
                },
              ]
            : []),
          ...(opts.excludeFaqWithQuestion
            ? [
                {
                  bool: {
                    must_not: {
                      terms: {
                        question: [opts.excludeFaqWithQuestion],
                      },
                    },
                  },
                },
              ]
            : []),
        ],
      },
    },
    _source: ['question', 'url'],
  },
});
